
// not required but useful if future validation / form handling is needed in future
export const CustomForm = class extends HTMLElement {
  // form?: HTMLFormElement | null;
  // errorNotice?: HTMLElement | null;

  constructor() {
    super();
    // this.handleSubmit = this.handleSubmit.bind(this);
  }
  // connectedCallback() {}
  // disconnectedCallback() {}
  // handleSubmit() {}
};

customElements.define("custom-form", CustomForm);
